import { useQuery } from '@apollo/client';
import React, { FC, useEffect, useState } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';

import { Promos } from 'Components/Promos';
import { GET_ARTICLES } from 'Queries';

import './Category.scss';

interface CategoryProps {
  articles: any[];
  category: any;
}

export const Category: FC<CategoryProps> = ({ articles: _articles, category }) => {
  // console.log('Articles', { articles });
  const { asPath } = useRouter();

  const [articles, setArticles] = useState<any[]>(_articles);
  const [page, setPage] = useState(1);

  const { data: articleData } = useQuery(GET_ARTICLES, {
    variables: {
      categorySlug: category.slug,
      page: page,
    },
    skip: page <= 1,
  });

  const more = () => setPage(page => page + 1);

  useEffect(() => {
    console.debug({ articleData });
    if (!articleData?.articles) return;
    setArticles(articles => [...articles, ...articleData.articles]);
  }, [articleData]);

  return (
    <div data-page="category" data-visible={true}>
      <Head>
        <title>{`${category.name}`} | The Platform UK</title>

        <meta property="og:site_name" content="The Platform" />
        <meta property="og:url" content={`https://platformonline.uk/${asPath}`} />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={`https://platformonline.uk/${asPath}`} />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@YourPlatformUK" />
      </Head>

      <div className={`section`}>
        <div className="container">
          <div className="section-label">
            <span dangerouslySetInnerHTML={{ __html: category.name }} />
          </div>

          {articles && <Promos articles={articles} isFormatted={true} />}

          {!(articles.length % 10) && (
            <div className="btn" onClick={more}>
              More
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
